export const loadingTypes = {
  level: "level",
  inPage: "in-page",
  sorting: "sorting",
  pagination: "pagination",
};